<template>
  <div id="alert-chart-app">
      <v-container class="highcharts-light alert-chart-container" fluid>
        <v-card
            outlined
        >
          <div class="chart-title">
            <span v-if="!(filterBy && categoryDisplay && metricDisplay)">&nbsp;</span>
            <span v-if="filterBy && categoryDisplay && metricDisplay">
              <span>For all {{categoryDisplay}} where {{filterByShort}}</span>
            </span>
            <span v-if="!filterBy && categoryDisplay && metricDisplay">
              <span>For all {{categoryDisplay}}</span>
            </span>
            <span v-if="splitSeries && chartsSeries && chartsSeries.length > 1">
              <span class="group-info">(Showing <span>{{ chartsSeries.length }}</span> of <span>{{ data.size }})</span></span>
            </span>
            <span v-if="!splitSeries && chartsSeries && chartsSeries[0].length > 1"> 
              <span class="group-info">(Showing <span>{{ chartsSeries[0].length }}</span> of <span>{{ data.size }}</span>)</span>
            </span>
          </div>
          <section :style="'max-height:'+ height+'px; height:'+ height +'px; overflow-y: auto;'">
            <v-container fluid class="pa-0">
              <div no-gutters class="vy-row pa-0 ma-0">
                <v-overlay
                    absolute
                    opacity=1
                    :value="loading"
                    color="var(--panel-background)"
                >
                  <v-progress-circular
                      indeterminate
                      color="var(--primary-btn-bg-color)"
                      size="64"
                  ></v-progress-circular>
                </v-overlay>
                
                <v-col cols="12" :lg="isViewMode && multipleChartsWide ? '6' : '12'" :xl="isViewMode && multipleChartsWide ? '3' : multipleChartsWide ? '6' : '12'"
                       class="pa-0 ma-0"
                       v-for="(series, index) in chartsSeries"
                       :key="'alert-chart-'+index+'-'+chartId">
                  <div 
                       class="alert-chart-container-wrapper">
                    <div class="highcharts-light alert-chart-container"
                         :id="'alert-chart-'+index+'-'+chartId">
                    </div>
                  </div>
                </v-col>
              </div>
            </v-container>
          </section>
        </v-card>
      </v-container>
  </div>
</template>

<script>
  import _ from 'lodash';
  import DataServiceSecure from "../../services/data-secure.service";
  import Highcharts from "highcharts/highstock.src";
  import UtilsService from "../../../../services/utils.service";
  import moment from "moment";

  export default {
    name: 'alert-chart',
    components: {
    },
    props: {
      category: {
        type: String,
        default: '',
      },
      categoryDisplay: {
        type: String,
        default: '',
      },
      metric: {
        type: String,
        default: '',
      },
      metricDisplay: {
        type: String,
        default: '',
      },
      filterBy: {
        type: String,
        default: '',
      },
      filter: {
        type: String,
        default: '',
      },
      groupBy: {
        type: Array,
        default: function() {
          return [];
        }
      },
      groupByDisplay: {
        type: Array,
        default: function() {
          return [];
        }
      },
      groupByColors: {
        type: Object,
        default: function() {
          return {};
        }
      },
      operation: {
        type: String,
        default: '',
      },
      critical: {
        type: String,
        default: '',
      },
      warn: {
        type: String,
        default: '',
      },
      info: {
        type: String,
        default: '',
      },
      start: {
        type: String,
        default: '',
      },
      end: {
        type: String,
        default: '',
      },
      showThresholds: {
        type: Boolean,
        default: true,
      },
      duration: {
        type: [Number,String],
        default: 0,
      },
      window: {
        type: [Number,String],
        default: 0,
      },
      height: {
        type: Number,
        default: 200,
      },
      ts: {
        type: Number,
        default: 0,
      },
      splitSeries: {
        type: Boolean,
        default: false,
      },
      isViewMode: {
        type: Boolean,
        default: false,
      },
    },
    data: function() {
      return {
        chartId: UtilsService.generateID(),
        chartsSeries: [ [] ],
        mounted: false,
        updatePending: false,
        data: [],
        groupByDisplayString: '',
        requestId: 0,
        loading: false,
      };
    },
    computed: {
      chartHeight: function() {
        let self = this;
        // todo this can be simplified
        if (self.splitSeries && ((self.isViewMode && self.chartsSeries.length > 2) || (!self.isViewMode && self.chartsSeries.length > 1))) {
          if (self.isViewMode && self.chartsSeries.length < 5) {
            return Math.max(100, self.height / 2);
          }
          return 100;
        }
        return self.height;
      },
      isPercentage: function() {
        return _.endsWith(this.metric, '.percent');
      },
      filterByShort: function() {
        let self = this;
        return self.filterBy && self.filterBy.length > 300 ? self.filterBy.substring(0,300) + '...' : self.filterBy;
      },
      multipleChartsWide: function() {
        let self = this;
        return self.splitSeries && self.chartsSeries && ((self.isViewMode && self.chartsSeries.length > 1) || (!self.isViewMode && self.chartsSeries.length > (self.height / 100)));
      },
    },
    created: function() {
      let self = this;
      self.updateData();
    },
    mounted(){
      let self = this;
      let chartConfiguration = self.getChartConfiguration(true);
      self.charts = [Highcharts.stockChart(`alert-chart-0-${self.chartId}`, chartConfiguration)];

      self.mounted = true;

      if (self.updatePending) {
        self.updateChart();
      }
    },
    methods: {
      genUniqueKey: function() {
        let self = this;
        return UtilsService.generateID();
      },
      hideTooltip: function() {
        let self = this;
        if (self.charts) {
          self.charts.forEach(c => c.tooltip.hide())
        }
      },
      updateChart: _.debounce(function() {
        let self = this;
        self.updateChart0(false);
      }, 250),
      
      updateChart0: function(stopLoading = true) {
        let self = this;
        if (self.mounted) {
          self.updatePending = false;
          let dataSeries = self.getSeries(self.data, !_.isEmpty(self.groupBy), self.metricDisplay, self.groupByColors);
          if (self.splitSeries && dataSeries.length > 1) {
            self.chartsSeries = dataSeries.map( s => [ s ] );
          } else {
            self.chartsSeries = [ dataSeries ];
          }

          this.$nextTick(() => {
            self.charts = [];
            self.chartsSeries.forEach((series, index) => {
              self.charts.push( Highcharts.stockChart(`alert-chart-${index}-${self.chartId}`, self.getChartConfiguration(true, series, self.isPercentage, self.ts)) );
            });

            if (stopLoading) self.loading = false;
          });
          // let chartConfiguration = self.getChartConfiguration(false, self.metricDisplay, self.data, self.isPercentage);
          // self.charts.update(chartConfiguration, true, true, false);
        }
      },
      updateData:function() {
        let self = this;
        if (self.metric) {

          self.loading = true;

          self.updateData0();

        } else if (self.mounted) {
          self.data = [];
        }
      },
      updateData0:  _.debounce(function() {
        let self = this;

        var params = {
          start: self.start,
          end: self.end,
          name: self.metric,
          resultType: 'trend',
          query: self.filter,
          group_by: _.isArray(self.groupBy) ? self.groupBy.join(',') : self.groupBy,
          // aggregation: selectedOptions.aggregateFunction,
          flatten: false,
          exclude_default_group: true,
          limit: self.splitSeries ? 30 : 15,
          include_group_nice_names: true,
        };

        var rId = ++self.requestId;
        DataServiceSecure
        .fetchMetrics(params)
        .then(function (data) {
          if (self.requestId === rId) {
            self.updatePending = true;
            self.data = data;
          }
        })
        .catch(function (error) {
          // todo show error
          console.error(error);
          let msg = _.get(error, 'response.data.message');
          console.error(msg);
          if (self.requestId === rId) {
            // if we timed out, try reducing the query window as small as possible
            if (msg && msg.includes('Read timed out')) {
              let endMoment = moment.utc(self.end, 'YYYY-MM-DDTHH:mm:ssZ');
              if (self.window && endMoment.diff(moment.utc(self.start, 'YYYY-MM-DDTHH:mm:ssZ'), 'hours')
                  > self.window) {
                self.start = endMoment.subtract(self.window, 'hours').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
                return;

              } else {
                if (endMoment.diff(moment.utc(self.start, 'YYYY-MM-DDTHH:mm:ssZ'), 'minutes') > self.duration) {
                  self.start = endMoment.subtract(self.duration, 'minutes').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
                  return;
                }
              }
              if (self.charts) {
                self.charts.forEach(c => c.hideNoData())
                self.charts.forEach(c => c.showNoData('Too much data to query'))
              }
            }
            self.loading = false;
          }
        });

      }, 500),
      getTrendBaseConfiguration: function(margins, ts, title) { // from trend.panel.vm
        let self = this;
        let plotLines = [];
        let plotBands = [];
        let softMax = 0;

        if (self.showThresholds) {

          let critical = self.isPercentage ? parseFloat(self.critical) || 0.0 : parseInt(self.critical) || 0;
          let warn = self.isPercentage ? parseFloat(self.warn) || 0.0 : parseInt(self.warn) || 0;
          let info = self.isPercentage ? parseFloat(self.info) || 0.0 : parseInt(self.info) || 0;

          let toCritical = 9999999;
          let toWarn = self.critical ? critical : 9999999;
          let toinfo = self.warn ? warn : self.critical ? critical : 9999999;

          if (self.operation === 'lt' || self.operation === 'lte') {
            toCritical = critical;
            toWarn = warn;
            toinfo = info;
          }

          let fromCritical = critical;
          let fromWarn = warn;
          let frominfo = info;

          if (self.operation === 'lt' || self.operation === 'lte') {
            fromCritical = 0;
            fromWarn = self.critical ? critical : 0;
            frominfo = self.warn ? warn : self.critical ? critical : 0;
          }

          if (self.operation === 'eq') {
            toCritical = fromCritical = critical;
            toWarn = fromWarn = warn;
            toinfo = frominfo = info;

          } else if (self.operation === 'ne') {
            toCritical = toWarn = toinfo = 9999999;
            fromCritical = fromWarn = frominfo = 0;
          }

          let yLabelLocation = self.operation === 'ne' || self.operation === 'eq' ? 6 :
              self.operation === 'gt' || self.operation === 'gte' ? -3 : 16;

          if (self.splitSeries) {
            critical += 0.5;
            warn += 0.5;
            info += 0.5;
            fromCritical += 0.5;
            fromWarn += 0.5;
            frominfo += 0.5;
          }
          
          if (self.critical) {
            plotBands.push({
              className: 'plot-band-critical',
              to: parseFloat(toCritical),
              from: parseFloat(fromCritical),
            });
            let className = 'plot-line '
                + (self.operation === 'gte' || self.operation === 'lte' || self.operation === 'eq'
                    ? 'plot-line-dashed '
                    : self.operation === 'gt' || self.operation === 'lt'
                        ? 'plot-line-dashed-solid '
                        : '')
                + (self.operation === 'ne' ? 'plot-line-ne' : 'plot-line-critical');
            let line = {
              className: className,
              value: parseFloat(critical),
              label: {
                text: '<span class="plot-line-label-critical">Critical Threshold</span>',
                useHTML: true,
                align: 'right',
                x: -10,
                y: yLabelLocation,
              },
              zIndex: 1,
            };
            plotLines.push(line);
          }
          if (self.warn) {
            plotBands.push({
              className: 'plot-band-warn',
              to: parseFloat(toWarn),
              from: parseFloat(fromWarn),
            });
            let className = 'plot-line '
                + (self.operation === 'gte' || self.operation === 'lte' || self.operation === 'eq'
                    ? 'plot-line-dashed '
                    : self.operation === 'gt' || self.operation === 'lt'
                        ? 'plot-line-dashed-solid '
                        : '')
                + (self.operation === 'ne' ? 'plot-line-ne' : 'plot-line-warn');
            let line = {
              className: className,
              value: parseFloat(warn),
              label: {
                text: '<span class="plot-line-label-warn">Warn Threshold</span>',
                useHTML: true,
                align: 'center',
                y: yLabelLocation,
              },
              zIndex: 1,
            };
            plotLines.push(line);
          }
          if (self.info) {
            plotBands.push({
              className: 'plot-band-info',
              to: parseFloat(toinfo),
              from: parseFloat(frominfo),
            });
            let className = 'plot-line '
                + (self.operation === 'gte' || self.operation === 'lte' || self.operation === 'eq'
                    ? 'plot-line-dashed '
                    : self.operation === 'gt' || self.operation === 'lt'
                        ? 'plot-line-dashed-solid '
                        : '')
                + (self.operation === 'ne' ? 'plot-line-ne' : 'plot-line-info');
            let line = {
              className: className,
              value: parseFloat(info),
              label: {
                text: '<span class="plot-line-label-info">Info Threshold</span>',
                useHTML: true,
                align: 'left',
                y: yLabelLocation,
              },
              zIndex: 1,
            };
            plotLines.push(line);
          }

          softMax = Math.max(parseFloat(critical) || 0, parseFloat(warn) || 0, parseFloat(info) || 0);

          if (self.operation === 'gte') {
            softMax += 2;
          } else if (self.operation === 'gt') {
            softMax++;
          }
        }

        let marginCfg = {};
        if(margins) {
          marginCfg = {
            chart: {
              marginTop: 20,
              marginBottom: 10,
              marginLeft: 45,
              marginRight: 20,

            }
          };
        }
        let xAxisTsPlotLine = {};
        if (ts) {
          xAxisTsPlotLine = {
            xAxis: {
              plotLines: [{
                value: ts,
              }],
            }
          }
        }
        
        let titleCfg = {};
        if (title) {
          titleCfg = {
            title: {
              text: title,
              align: 'left',
              x: 45,
            },
            yAxis: {
              // endOnTick: false,
              min: 0, // todo remove
              softMax: 1.5,
              minRange: 1.5,
              tickInterval: 1
            },
          }
        }

        return _.merge({},
            {
              title: false,
              chart: {
                styledMode: true,
                height: self.chartHeight,
                zoomType: 'x', // let the user select to zoom
                panning: true, // keep panning enabled, but use shift to pan
                panKey: 'shift',
                // pinchType: 'x' // this didn't help prevent y zooming for mouse wheel
                spacing: [0, 0, 0, 0],
              },
              time: {useUTC: false},
              tooltip: {
                outside: true,
                followPointer: false,
                shared: true,
                split: false,
                dateTimeLabelFormats: {
                  millisecond: "%a, %b %e, %H:%M:%S",
                },
              },
              legend: {
                enabled: false,
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
                borderWidth: 0,
                alignColumns: false
              },
              plotOptions: {
                series: {
                  marker: {
                    enabled: true,
                    symbol: 'circle',
                    radius: 0.1
                  },
                  animation: false,
                  events: {},
                  label: {
                    enabled: false,
                  },
                }},
              series: [{data: [0], name: '', softThreshold: false}],
              xAxis: {
                type: 'datetime',
                ordinal: false,
                minRange: 30000,
                showLastLabel: true,
              },
              yAxis: {
                title: {text: null},
                opposite: false,
                showLastLabel: true,
                startOnTick: true,
                endOnTick: false,
                min: 0,
                // tickAmount: 5,
                softMax: softMax,
              },
              lang: {
                noData: "No Data To Display"
              },
              credits: {enabled: false},
              rangeSelector: {
                enabled: false,
              },
              scrollbar: { // todo WIP need to be enabled for smooth pan, but can't quite get it to completely hide
                height: 0,
                margin: 0,

              },
              navigator: {
                enabled: false,
              }
            }, {
              yAxis: {
                plotLines: plotLines,
                plotBands: plotBands
              }
            }, xAxisTsPlotLine, marginCfg, titleCfg);
      },
      getSeries: function (data, isGroupBy, metricDisplayName, colors) {
        moment.tz.setDefault(moment.tz.guess());
        var series = [];
        if (!_.isEmpty(data) && !_.isEmpty(data.trend)) {
          let first = _.find(data.trend, t => t !== null);
          if (first && _.isArray(first.group)) {

            _.forEach(data.trend, v => {
              if (v && v.group) {
                let nameRaw = _.map(v.group, g => g[1]).join(', ');
                let name = _.map(v.group, g => {
                  return g[3] ? g[3].replace(/{{time:(\d+)}}/,
                          (match, p1) => moment.utc(Number(p1)).local().format('DD MMM YYYY - HH:mm:ss'))
                      : g[1].replaceAll('_', ' ');
                }).join(', '); // todo these names need to be looked up if they are ids
                if (!isGroupBy && name === '') {
                  name = metricDisplayName;
                } else if (name === '') {
                  name = '(empty)';
                } else if (isGroupBy && name.match(/^\*(, \*)*$/)) { // This regex matches one or more "*"s in the format "*, *, *" etc.
                  name = '(none)';
                }

                let seriesConfig = {
                  name: name,
                  data: v.data,
                  softThreshold: false, // https://github.com/highcharts/highcharts/issues/6894
                };
                if (colors && _.get(colors, nameRaw)) {
                  seriesConfig.colorIndex = _.get(colors, nameRaw);
                }
                series.push(seriesConfig);
              }

            });
          }
        }
        return series;
      },
      getChartConfiguration: function (margins, series = [], isPercentage, ts) {  // from trend.panel.vm
        let self = this;
          var configuration = self.getTrendBaseConfiguration(margins, ts, 
              self.splitSeries && series[0] ? series[0].name : undefined);

        // series = _.orderBy(series, 'sum', 'desc');
        // // series = _.sortBy(series, ['name']);
        // // let empty = _.remove(series, {name:'(empty)'});
        // // let none = _.remove(series, {name:'(none)'});
        // // if (!_.isEmpty(empty)) series.push(...empty);
        // // if (!_.isEmpty(none)) series.push(...none);

        if (isPercentage) {
          _.forEach(series, function (s) {
            _.assign(s, {
              tooltip: {
                valueDecimals: 1,
                valueSuffix: '%',
              },
            });
          });

          _.assign(configuration.yAxis, {
            labels: {
              format: '{value:.0f} %',
            },
          });

        }

        _.set(configuration, 'series', series);

        return configuration;
      }
    },
    watch: {
      metric: function() { this.updateData() },
      filter: function() { this.updateData() },
      groupBy: function() { this.updateData() },
      groupByDisplay: function() { this.groupByDisplayString = _.isArray(this.groupByDisplay) ? this.groupByDisplay.join(', ') : this.groupByDisplay },
      start: function() { this.updateData() },
      end: function() { this.updateData() },

      data: function() { this.updateChart0() },
      operation: function() { this.updateChart() },
      critical: function() { this.updateChart() },
      warn: function() { this.updateChart() },
      info: function() { this.updateChart() },
    }
  }
</script>

<style lang="scss" scoped>
  .alert-chart-container {
    max-width: unset!important;
    margin-left: 0!important;
    margin-right: 0!important;
    padding-top: 0;
    padding-bottom: 0;

    margin-top: 0;
    height: 100%;
    width: 100%;

    .group-info {
      font-style: italic;
      white-space: nowrap;
    }

  }

  .alert-chart-container-wrapper {
    max-width: unset!important;
    margin-left: 0!important;
    margin-right: 0!important;
    padding-top: 0;
    padding-bottom: 0;

    margin-top: 0;
  }

  .chart-title {
    font-weight: 600;
    font-size: 14px;
    color: var(--filter-text-color);
    padding: 14px 20px;
    background-color: var(--panel-background);
  }
  
  .alert-chart-container-title {
    font-weight: bold;
    font-size: 12px;
    color: var(--filter-text-color);
    padding: 0 0 0 44px;
  }
</style>
<style lang="scss">
  .alert-chart-container {
    .highcharts-title {
      font-weight: bold;
      font-size: 12px;
      fill: var(--filter-text-color);
      text-transform: unset;
    }
  }

  #alert-chart-app .v-application--wrap {
    min-height: 0;
  }

  #alert-chart-app .highcharts-plot-line-label {
    font-family: var(--font-family);
    font-weight: 600;
    font-size: 9px;
    background-color: var(--panel-background);
  }

  .plot-band-critical {
    fill: var(--bad-color);
    fill-opacity: 0.25;
  }
  .plot-band-warn {
    fill: var(--fair-color);
    fill-opacity: 0.25;
  }
  .plot-band-info {
    fill: #0073b7;
    fill-opacity: 0.25;
  }

  .plot-line {
    stroke-width: 2px;
  }
  .plot-line-dashed {
    stroke-dasharray: 6;
  }
  .plot-line-dashed-solid {
    stroke-dasharray: 2;
  }
  .plot-line-critical {
    stroke: var(--bad-color);
  }
  .plot-line-warn {
    stroke: var(--fair-color);
  }
  .plot-line-info {
    stroke: #0073b7;
  }
  .plot-line-ne {
    stroke: #ffffff;
  }
  .plot-line-label-critical {
    padding: 0 3px;
    color: var(--bad-color);
    background-color: var(--panel-background);
  }
  .plot-line-label-warn {
    padding: 1px 3px;
    color: var(--fair-color);
    background-color: var(--panel-background);
  }
  .plot-line-label-info {
    padding: 1px 3px;
    color: #0073b7;
    background-color: var(--panel-background);
  }
</style>
